import { useState, useRef } from 'react'
import { JSONFetcher, themeColor } from 'shared'

export const AccordeonItem = (props) => {
  const [active, setActive] = useState('')
  const [height, setHeight] = useState('0px')
  const [rotate, setRotate] = useState('module-accordeon-item__icon')
  const [linkText, setLinkText] = useState(I18n.t('misc.more'))
  const content = useRef(null)

  const toggleAccordion = () => {
    setActive(active === '' ? 'active' : '')
    setHeight(active === 'active' ? '0px' : `${content.current.scrollHeight}px`)
    setRotate(active === 'active' ? 'module-accordeon-item__icon' : 'module-accordeon-item__icon rotate')
    setLinkText(active === 'active' ? I18n.t('misc.more') : I18n.t('misc.less') )
  }

  return <div className='module-accordeon-item'>
    <button className={`module-accordeon-item__container ${active}`} onClick={toggleAccordion}>
      <label className='generic-custom-radio-field m-0'>
        <Checkbox {...props}/>
        <span className='module-accordeon-item__title'>{props.title}</span>
      </label>
      <ChevronWithLink className={`${rotate}`} width={'8'} linkText={linkText} />
    </button>
    <div
      ref={content}
      style={{ maxHeight: `${height}` }}
      className='module-accordeon-item__content'
    >
      <div dangerouslySetInnerHTML={{ __html: props.content }} style={{ borderTop: `1px solid ${themeColor('gray-500')}`, padding: '16px 0 16px 0'}} />
    </div>
  </div>
}

const ChevronWithLink = (props) => {
  const xPosition = props.direction === "left" ? { left: -80 } : { right: -80 }

  return <>
    <span className='link-text'>{props.linkText}</span>
    <i id={props.id} className={`hidden desktop:block fa fa-angle-down ${props.className}`} style={xPosition} />
  </>
}

const Checkbox = (props) => {

  const [checked, setChecked] = useState(props.checkboxValue === 'true')

  const handleChange = () => {
    JSONFetcher.put({
      url: props.checkboxUrl, success: () => {
        setChecked(!checked)
      }
    })
  }

  if (!props.checkboxUrl) return null

  return <>
    <input type='checkbox' onChange={handleChange} checked={checked} />
    <span className='generic-custom-radio' style={{ display: 'inline-flex' }} />
  </>
}
